import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiService, ICslb } from '@ebb-v2/ebb-integration';


@Injectable({
  providedIn: 'root'
})
export class CslbLicenseService {

  constructor(private api: ApiService)  { }

  public getcslbLicense(licenseNumber: string): Observable<ICslb> {
    return this.api
      .get(
        `/LicensesValidation/GetContractorInformation?licenseNumber=${licenseNumber}`
      )
      .pipe(map(res => res as ICslb));
  }
}
